var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",attrs:{"id":"container"}},[(_vm.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('div',{staticClass:"no-msg"},[_c('img',{attrs:{"src":require("@/assets/images/system/no-data.png"),"alt":""}}),_c('p',[_vm._v("暂无应用介绍~")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }